import { useEffect } from 'react';

export function useVersionCheck(intervalMs = 60000) {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
        const data = await res.json();
        const localVersion = localStorage.getItem('appVersion');

        if (localVersion && localVersion !== data.version) {
          localStorage.setItem('appVersion', data.version);
          window.location.reload(true);
        } else if (!localVersion) {
          localStorage.setItem('appVersion', data.version);
        }
      } catch (e) {
        console.error('Erro ao verificar versão:', e);
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, intervalMs);
    return () => clearInterval(interval);
  }, [intervalMs]);
}